<button mat-icon-button (click)="openDialog()" [matTooltip]="tooltip ?? ''">
  <mat-icon svgIcon="upload" color="primary"></mat-icon>
  <span *ngIf="label">&nbsp;{{ getTranslatedLabel() }}</span>
</button>